import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { SiteConfigContext } from '../SiteConfigProvider'
import { Link } from '@jelly/ui'

const DisclosureWrapper = styled.p`
	background: ${({ theme }) => `${theme.colors.lightGrey}`};
	color: inherit;
	font-size: 11px;
	margin: 0;
	padding: 10px 7% 10px;
	text-align: center;
	min-height: 30px;
	width: 100%;
	letter-spacing: -0.07px;
	line-height: 0.875rem;
	${({ theme }) => theme.fonts.primarySemiBold};

	a {
		color: ${({ theme }) => `${theme.colors.secondary}`};
		text-decoration: underline;
	}

	${({ theme }) => theme.MQ.XS} {
		padding: 10px 10% 10px;
	}

	${({ theme }) => theme.MQ.S} {
		padding: 7px 15% 7px;
	}
`

/**
 *	Advertising Disclaimer and optional Ad Leaderboard spot
 */
export function AdvertisingDisclosure() {
	const {
		siteConstants: {
			META_DATA: { applicationName },
			SITE_HOST,
		},
	} = useContext(SiteConfigContext)

	return (
		<>
			<DisclosureWrapper>
				{applicationName} receives compensation from some of the companies listed on this page.{' '}
				<Link href={`${SITE_HOST}/advertising-disclosure/`} variant="secondary">
					Advertising Disclosure
				</Link>
			</DisclosureWrapper>
		</>
	)
}
